/**
 * The TanStack Query retry policy main.tsx installs as the default.
 *
 * Do not retry auth failures. A 401/403 means the session is broken or the
 * read is refused (the API client's silent-refresh + bounce-to-login already
 * ran in the response middleware); retrying 3x just hammers the surface with
 * the same token and produces the piecemeal-failure console noise. Retry other
 * (transient) errors up to 3x as before.
 *
 * The predicate reads `status` off the error, so a query function that throws
 * a bare Error is retried even on a 403. GH #1939: the Organization Profile
 * read threw `new Error(...)` and re-issued a refused read three more times.
 * A query function that can be refused carries `status` on what it throws.
 *
 * It lives here rather than in main.tsx so a page test can run the real
 * predicate; main.tsx renders the app on import.
 */

export function isAuthStatus(error: unknown): boolean {
  const status = (error as { status?: number } | null)?.status;
  return status === 401 || status === 403;
}

export function defaultQueryRetry(failureCount: number, error: unknown): boolean {
  if (isAuthStatus(error)) return false;
  return failureCount < 3;
}
